import { makeStyles } from '@material-ui/core/styles'
import { Button, Checkbox } from '@mui/material' // Imported Checkbox component
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import LoadingModal from 'src/components/common/LoadingModal'

const LifeTermsAndConditions = () => {
  const classes = useStyles() // Added useStyles hook for styling
  const [loading, setLoading] = useState(false)
  const [checkboxData, setCheckboxData] = useState({
    detailsProvided: false,
    kycDetails: false,
    proposerDetailsForm: false,
    grantAuth: false,
    insuranceBroker: false,
  })
  const history = useHistory()

  useEffect(() => {}, [])

  // Removed fetchToken, fetchFullQuoteDetails, fetchProposerDetails, saveMetadataAndNavigate, and saveISNPStatusTasks functions and related logic

  const handleBack = () => {
    history.push(
      '/individual/dashboard/buyPolicy/life/insuranceDetails/member-details'
    )
  }

  const handlePay = async () => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
      alert('Payment')
    }, 1000)
  }

  const handleChange = (event) => {
    setCheckboxData({
      ...checkboxData,
      [event?.target?.name]: event?.target?.checked,
    })
  }

  const isPayButtonEnabled = () => {
    let isEnabled = true
    Object.keys(checkboxData)?.forEach((key) => {
      if (!checkboxData[key]) {
        isEnabled = false
      }
    })
    return isEnabled
  }

  return (
    <>
      <LoadingModal loading={loading} />
      <div className={classes.mainContainer}>
        <div>
          <div className={classes.title}>
            <span className={classes.title}>
              Terms & Conditions or Declaration
            </span>
          </div>
          <div>
            <div className={classes.conditions}>
              <Checkbox
                id='detailsProvided'
                name='detailsProvided'
                checked={checkboxData?.detailsProvided}
                onChange={handleChange}
              />
              <label htmlFor='detailsProvided'>
                All details provided, including medical declarations, are true
                and correct to my knowledge.
              </label>
            </div>
            <div className={classes.conditions}>
              <Checkbox
                id='insuranceBroker'
                name='insuranceBroker'
                checked={checkboxData?.insuranceBroker}
                onChange={handleChange}
              />
              <label htmlFor='insuranceBroker'>
                I appoint Trovity Insurance Broker Pvt. Ltd. as my Insurance
                Broker.
              </label>
            </div>
            <div className={classes.conditions}>
              <Checkbox
                id='kycDetails'
                name='kycDetails'
                checked={checkboxData?.kycDetails}
                onChange={handleChange}
              />
              <label htmlFor='kycDetails'>
                I understand that the KYC details will be verified as per the
                mandatory IRDAI Master Guidelines, and the details will be
                shared with the Insurer for policy issuance.
              </label>
            </div>
            <div className={classes.conditions}>
              <Checkbox
                id='grantAuth'
                name='grantAuth'
                checked={checkboxData?.grantAuth}
                onChange={handleChange}
              />
              <label htmlFor='grantAuth'>
                I grant them authorization to represent me to Insurance
                Companies/Agencies for my Insurance requirements.
              </label>
            </div>
            <div className={classes.conditions}>
              <Checkbox
                id='proposerDetailsForm'
                name='proposerDetailsForm'
                checked={checkboxData?.proposerDetailsForm}
                onChange={handleChange}
              />
              <label htmlFor='proposerDetailsForm'>
                I acknowledge and accept the Proposer details form.
              </label>
            </div>
          </div>
          <div className={classes.buttonItems}>
            <div>
              <Button
                type={'button'}
                onClick={handleBack}
                className={classes.backButton}
                id='backButton'
              >
                Back
              </Button>
            </div>
            <div>
              <Button
                className={`${classes.payButton} ${
                  !isPayButtonEnabled() ? classes.disabledButton : ''
                }`}
                onClick={handlePay}
                disabled={!isPayButtonEnabled()}
                id='payButton'
              >
                Ensure and Insure: Pay Now!
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default LifeTermsAndConditions

const useStyles = makeStyles({
  termsAndConditions: {
    padding: '30px 80px 30px 80px',
    backgroundColor: 'white',
  },
  title: {
    fontFamily: 'Roboto',
    fontSize: '19px',
    marginBottom: '20px',
    paddingBottom: '20px',
    fontWeight: '600',
  },
  quoteListContainer: {
    display: 'flex',
    gap: '10px',
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    width: '100%',
  },
  termsContainer: {
    width: '66%',
  },
  termsTitle: {
    fontFamily: 'Roboto',
    fontSize: '19px',
  },
  termsTitleContainer: {
    border: '1px dashed',
    borderRadius: '10px',
    display: 'flex',
    padding: '20px',
    marginBottom: '30px',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '20px',
    marginTop: '30px',
  },
  termsContent: {
    fontFamily: 'Roboto',
    fontStyle: 'italic',
    fontSize: '17px',
    display: 'flex',
    lineHeight: '1.5',
  },
  termsContentDescription: {
    color: '#619FAF',
    fontFamily: 'Roboto',
    fontStyle: 'italic',
    fontSize: '16px',
    lineHeight: '1.5',
  },
  termsReviewContent: {
    fontFamily: 'Roboto !important',
    fontSize: '16px !important',
    color: '#2CA9CB !important',
    textDecoration: 'underline !important',
    textTransform: 'initial !important',
  },
  conditionsCheck: {
    marginLeft: '10px',
  },
  conditionsContentCheck: {
    fontFamily: 'Roboto',
    fontSize: '16px',
  },
  policyPeriod: {
    marginBottom: '30px',
  },
  policyPeriodTitle: {
    marginBottom: '20px',
  },
  policyPeriodTitleName: {
    fontFamily: 'Roboto',
    fontSize: '19px',
  },
  policyItems: {
    display: 'flex',
    border: '1px',
    background: 'linear-gradient( #EF669B -760%, #FFFFFF 150%)',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0px 4px 4px 0px #00000040',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '30px',
  },
  policyOtherItems: {
    display: 'flex',
    border: '1px',
    background: 'linear-gradient( #EF669B -760%, #FFFFFF 150%)',
    boxShadow: '0px 4px 4px 0px #00000040',
    padding: '30px 22px',
    borderRadius: '10px',
    marginLeft: '30px',
  },
  policyInput: {
    flex: '1',
  },
  policyOtherInput: {
    marginTop: '20px',
    flex: '1',
  },
  policyYear: {
    fontFamily: 'Roboto',
    fontSize: '17px',
  },
  policyYearRate: {
    fontFamily: 'Roboto',
    fontSize: '17px',
    marginLeft: '40px',
  },
  policyPremium: {
    fontFamily: 'Roboto',
    fontSize: '17px',
  },
  policyOtherRates: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    marginLeft: '76px',
    color: '#A45E4C',
  },
  policySaveRate: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    marginLeft: '60px',
    color: '#2AB29B',
  },
  buttonItems: {
    display: 'flex',
    marginLeft: '10px',
    padding: '20px',
  },
  backButton: {
    color: '#2BA6C8 !important',
    fontFamily: 'Roboto !important',
    fontSize: '16px !important',
    cursor: 'pointer !important',
    width: '120px',
    border: '1px !important',
    padding: '10px !important',
    borderRadius: '10px !important',
    background: '#E4EFF2 !important',
    textTransform: 'none !important',
    fontWeight: '600 !important',
  },
  payButton: {
    fontFamily: 'Roboto !important',
    fontSize: '16px !important',
    color: 'white !important',
    background:
      'linear-gradient(228.98deg, #4EC4E4 9.13%, #0288AC 167.68%) !important',
    cursor: 'pointer !important',
    width: '265px',
    border: '1px !important',
    padding: '10px !important',
    borderRadius: '10px !important',
    marginLeft: '15px !important',
    textTransform: 'none !important',
    fontWeight: '600 !important',
  },
  digitContainer: {
    border: '1px',
    background: 'linear-gradient( #EF669B -760%, #FFFFFF 150%)',
    boxShadow: '0px 5px rgba(0,0,0,0.1)',
    padding: '30px 20px',
    borderRadius: '10px',
    marginLeft: '30px',
  },
  digitItems: {
    marginLeft: '11px',
    marginBottom: '20px',
  },
  digitImage: {
    width: '60px',
    marginBottom: '-5px',
  },
  digitContent: {
    marginBottom: '15px',
  },
  digitInput: {
    fontFamily: 'Roboto',
    fontSize: '10px',
  },
  digitBaseInput: {
    fontFamily: 'Roboto',
    fontSize: '14px',
  },
  digitOtherContent: {
    marginLeft: '60px',
    marginBottom: '25px',
  },
  digitOtherInput: {
    fontFamily: 'Roboto',
    fontSize: '17px',
    display: 'flex',
    color: '#2BA6C8',
  },
  digitCoverRate: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    marginLeft: '9px',
  },
  digitInputRate: {
    marginBottom: '28px',
    marginLeft: '105px',
  },
  digitRate: {
    fontFamily: 'Roboto',
    fontSize: '16px',
  },
  totalPremium: {
    display: 'flex',
    border: '1px solid #EF669B',
    padding: '10px 10px',
    borderRadius: '10px',
    backgroundColor: 'white',
  },
  premiusubTitle: {
    fontFamily: 'Roboto',
    fontSize: '16px',
  },
  premiumRate: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    marginLeft: '142px',
  },
  popoverHeading: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    textTransform: 'uppercase',
    color: '#000000',
  },
  popoverContent: {
    textAlign: 'center',
    // opacity: '40%',
    boxShadow: '0px 0px 5px 0px #00000026',
  },
  detailsContainer: {
    display: 'flex',
    marginBottom: '20px',
    gap: '10px',
  },
  nameDetails: {
    color: '#47BBDB',
    fontSize: '16px',
    fontFamily: 'Roboto',
  },
  otherDetails: {
    color: '#000000',
    fontSize: '13px',
    fontFamily: 'Roboto',
  },
  otherSubDetails: {
    color: '#959595',
    fontSize: '11px',
    fontFamily: 'Roboto',
  },
  errorMessageContainer: {
    padding: '40px',
  },
  errorContainer: {
    textAlign: 'center',
    background: 'linear-gradient( #EF669B -760%, #FFFFFF 100%)',
    border: 'none',
    padding: '50px 80px 50px 80px',
    boxShadow: '0px 6px 8px 0px #4DC3E333',
    borderRadius: '10px',
  },
  errorTextContainer: {
    paddingBottom: '10px',
  },
  errorText: {
    fontSize: '18px',
    textAlign: 'center',
  },
  errorBackContainer: {
    textAlign: 'center',
    padding: '10%',
  },
  disabledButton: {
    opacity: '0.5',
  },
  checkboxControl: {
    cursor: 'pointer',
    height: '15px',
    width: '15px',
  },
  conditionsContentDescription: {
    fontFamily: 'Roboto',
    fontSize: '16px',
  },
  conditions: {
    marginBottom: '15px',
    display: 'flex',
    alignItems: 'center',
  },
  conditionsContentCheckForReview: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    display: 'flex',
    gap: '5px',
  },
  termsPolicy: {
    fontFamily: 'Roboto !important',
    fontSize: '16px !important',
    color: '#2CA9CB !important',
    textDecoration: 'underline !important',
    textTransform: 'initial !important',
    cursor: 'pointer',
    fontStyle: 'italic',
  },
})
